import $ from 'jquery';
import magnificPopup from 'magnific-popup';


/* Global variables
********************************************/


/* Modals
********************************************/

if ($.fn.magnificPopup) {
	$('.js-modal-image').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		titleSrc: 'test',
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close c-modal-close--outside">&#215;</button>'
	});

	$('.c-article__image-link').not('[target="_blank"]').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close">&#215;</button>'
	});

	$('.js-gallery-slider, .js-gallery-slider-3').magnificPopup({
		delegate: '.gallery-item a, .c-hero__gallery-item a',
		type: 'image',
		mainClass: 'c-modal-gallery',
		closeOnContentClick: false,
		closeBtnInside: false,
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			arrowMarkup: '<button title="%title%" type="button" class="c-slider__arrow c-slider__arrow--%dir%"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></button>',
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			verticalFit: true
		},
		closeMarkup: '<a href="#" title="%title%" class="c-modal-close c-modal-close--outside"></button>'
	});

	$('.js-modal-base').magnificPopup({
		closeOnContentClick: false,
		showCloseBtn: false,
	});

	// close modal
	$('body').on('click', '.js-modal-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

}



/* Wistia Modals
********************************************/

/**
 * Wistia has this functionality built in if you start the href with only "#wistia_XXX", XXX being video ID, but the
 * native functinality it provides fails to open a modal when there's a video with the same video ID displayed inline
 * on the page so I've implemented this to fix that.
 *
 * This also fails, when using span.wistia_embed id attr as a matcher argument as described here:
 * https://wistia.com/support/developers/player-api#wistia-api-matcher , it appends an iframe to inline video when the
 * modal closes.
 */
$( document ).on( 'click', '[href^="#wistia-modal-"]', function ( e ) {
	e.preventDefault();
	const $playLink = $( $( this ).attr( 'href' ) + ' a' );
	if ( $playLink.length ) {
		$playLink[0].click();
	}
} );
